'use client';

import { useTransition } from 'react';
import { ColorButton } from '@packages/shared/src/ui/ColorButton/ColorButton';
import type { DimensionFragmentFragment } from '@packages/gql/generated/shopping/graphql';
import type { VariationSelectionOnSelectHandler } from '../../types';
import { templateNames } from '../../../helpers/getResponsiveAkamaiTemplate/config';
import { useVariationFormattedLink } from '../../utils/useVariationFormattedLink';

export type ColorTileProps = VariationSelectionOnSelectHandler & {
  /**
   * The GraphQL ProductDimensionValue data for the given product
   */
  data: DimensionFragmentFragment['values'][number];
};

export const ColorTile = ({ data, onSelect }: ColorTileProps) => {
  const { displayText, image, isSelected, rgb, sku, variationMainImage } = data;

  const [isPending, startTransition] = useTransition();
  const { getOnSelectCallback } = useVariationFormattedLink();
  const onClickHandler = getOnSelectCallback({ sku, onSelect });

  // determine which image to use and append the template
  const imageUrl =
    variationMainImage || image
      ? `${variationMainImage || image}?${templateNames.gallery}`
      : undefined;

  return (
    <ColorButton
      onClick={() => startTransition(() => onClickHandler())}
      size="large"
      image={imageUrl}
      fitBackgroundImage
      square
      color={rgb ? `#${rgb}` : undefined}
      name={displayText || ''}
      active={!!isSelected}
      isSelected={isPending}
      /* this is only for A11Y needs (CROSS-1372) */
      aria-pressed={!!isSelected}
    />
  );
};
